@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

<kb-html [appEditorId]="editorIds?.tableDom"  [html]="attributes.tableDom" [attributeAllowlist]="attributeAllowlist"></kb-html>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
